<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
        <span class="search_span_width">
        	<span class="search_span_width_part1">直播间状态：</span>
        	<Select v-model="search.status" clearable  style="width:200px">
            <Option :value='4'>流地址创建中</Option>
            <Option :value='5'>创建视频流成功</Option>
            <Option :value='6'>创建视频流失败</Option>
            <Option :value='10'>开始会话成功</Option>
            <Option :value='11'>开启会话失败</Option>
            <Option :value='90'>直播结束</Option>
            <Option :value='98'>会话关闭失败</Option>
            <Option :value='99'>会话关闭</Option>
        	</Select>
        </span>
        <span class="search_span_width">
           <span class="search_span_width">
             <span class="search_span_width_part1">直播间名称：</span>
                   <Input v-model="search.name" style="width: 130px" />
            </span>
        </span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="xiaoweiStudioList()">搜索</Button>
      </Card>
      <Card>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="voice_list"></Table>
		      <Page :total="recordTotal" :current="page" :page-size="20" :show-elevator="true" @on-change="xiaoweiStudioList"/>
        </Card>
      </Card>
    </Content>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
		search : {
      status:5,
      name:'',
		},
		page: 1,
		loading2: false,
		recordTotal:0,
		showmodal:false,
		voice_list:[],
	
		tableColumns:[
      { title: 'ID', key: 'id', align: 'center',width:'80px' },
	  { title: 'GROUP', key: 'group_id', align: 'center',width:'80px' },
	  { title: '类型', key: 'scene_type', align: 'center',width:'80px',render:(h,params) =>{
		    var name = '未知';
		    if(params.row.scene_type==1){
		      name = '客户端';
		    }
		    if(params.row.scene_type==2){
		      name = '对话';
		    }
			if(params.row.scene_type==3){
			  name = '开放平台';
			}
		    return h('span',{},name);
		  }  },
      { title: '直播间名称', key: 'name', align: 'center' },
	  { title: '用户', key: 'user_id', align: 'center' },
      { title: '应用方key', key: 'appkey', align: 'center',width:'220px' },
      { title: '发音人ID', key: 'spk_id', align: 'center' },
      { title: '人物ID', key: 'figure_id', align: 'center' },
      { title: '开启时间', key: 'start_time', align: 'center' },
      { title: '操作', key: 'action', align: 'center',width: 200,
        render: (h, params) => {
          let btns=[]
          if (params.row.status == '5') {
            var txt = '关闭会话';
            btns.push(
                h('Button', {
                  props: { type: 'error', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px'},
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        content: '<p>确定'+txt+'吗？</p>',
                        onOk: () => {
                          this.closeSiaoweiSession(params.row.id);
                        }
                      });
                    }
                  }
                }, txt),
            );
          }
		  btns.push(
		      h('Button', {
		        props: { type: 'info', size: 'small' },
		        style: { marginRight: '5px', marginBottom: '5px'},
		        on: {
		          click: () => {
		            navigator.clipboard.writeText(params.row.stream_addr)
		                  .then(() => {
		                    this.copiedMessage = '文本已复制！';
		                  })
		                  .catch(e => {
		                    this.copiedMessage = '复制失败，请检查权限。';
		                  });
		          }
		        }
		      }, '复制地址'),
		  );
          return h("div",btns);
        }
      }
		]
	}
  },
  mounted:function(){
    this.xiaoweiStudioList();
  },
  computed:{

  },
  methods:{
    xiaoweiStudioList(page=this.page) {
		this.page = page;
		let p = {'page' : page}
		let params = Object.assign(this.search, p);
		this.http1.get('/studio/xiaoweiStudioList',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.voice_list = data.data.list;
			
			this.recordTotal = data.data.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
  closeSiaoweiSession(xiaowei_studio_id){
    this.http1.get('/studio/closeSiaoweiSession',{params:{id:xiaowei_studio_id}}).then(response=>{
      let data=response.data;
      if(data.code!==0) {
        this.$Message.error(data.message);
        return false;
      } else{
        this.$Message.info(data.message);
        this.xiaoweiStudioList(this.page);
        return true;
      }
    });
  },
  }

}
</script>
